import {
   styled
  ,clsx
  ,TableCell 
  ,TableHead 
  ,TableRow 
  ,TableSortLabel 
} from 'external/material'

import {useSearchParams, useLocation} from 'external/react'
import useTranslations from 'hooks/translations'
import SortLink from './SortLink' 

const defaultStyles = {
  "& .headersRow": {
    color: '#50566e',
    '& > th': {
      backgroundColor: '#ffffff',
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5
    }
  },
  "& .headerLabel": {
    color: '#9ea5b9',
    fontWeight: 500
  },
  "& .visuallyHidden": {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}

export default function makeHeadComponent(headCells, styles) {
  const Head = styled(TableHead)(styles)
  return function HeadWithSort(props) {

    const {includeActions = true, actionsLabel} = props
    const [search] = useSearchParams()
    const searchOrder = search.get('orderBy') || false
    const {translate} = useTranslations()
    const order = searchOrder ? (searchOrder.startsWith('-') ? 'desc' : 'asc') : undefined
    const orderBy = searchOrder ? (order == 'asc' ? searchOrder : searchOrder.substring(1)) : undefined
    return (
      <Head sx={defaultStyles}>
        <TableRow className="headersRow">
            {headCells.map(({id, align, disablePadding}) => (
              <TableCell
                key={id}
                align = {align}
                padding={disablePadding ? 'none' : 'normal'}
                sortDirection={order}
              >
                <TableSortLabel
                  className={clsx("headerLabel", id)}
                  property={id}
                  order={order}
                  orderBy={orderBy}
                  active={orderBy === id}
                  direction={order}
                  component={SortLink}
                >
                  {translate(`${id}-header`)}
                  {orderBy === id ? (
                    <span className="visuallyHidden">
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ))}
            {includeActions && (<TableCell className="actions" align="center">{actionsLabel && <label className={clsx('headerLabel', 'actions-label')}>{translate(actionsLabel)}</label>}</ TableCell>)}
        </TableRow>
      </Head>
    )
  }
}
